/* pack sizes + minimum 3 tins (product page, flavor cards, mix builder) */
(function(){
  var S=window.SMELO||{},FL=S.flavors||[],MIN=3,TIERS=S.tiers||[[3,5],[5,10]];
  if(!FL.length)return;
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var num=function(el){return el?(+el.textContent||0):0};
  var note='Minimum order: '+MIN+' tins.';
  var st=document.createElement('style');
  st.textContent='.packs{display:flex;gap:.5rem;flex-wrap:wrap;margin:.35rem 0 .2rem}.packs .pk{flex:1 1 7rem;min-width:0;border:1.5px solid var(--line,#E6E6E6);background:var(--bg,#fff);color:inherit;border-radius:.8rem;padding:.55rem .6rem;font:inherit;font-weight:800;font-size:.86rem;cursor:pointer;text-align:center;line-height:1.2}.packs .pk small{display:block;font-weight:600;font-size:.7rem;opacity:.75;margin-top:.15rem}.packs .pk[aria-pressed="true"]{border-color:var(--pink,#302A7E);box-shadow:0 0 0 1px var(--pink,#302A7E);background:rgba(48,42,126,.07)}.pk-note{margin:.1rem 0 .4rem;font-size:.74rem;opacity:.75}#mix .bar,#mix .sumline:not(.total){display:none}';
  document.head.appendChild(st);

  /* FAQ text: no volume discount any more */
  $$('.fm-i *').forEach(function(el){
    if(el.children.length)return;
    var t=el.textContent,o='You can simply order 1 tin. Choose 3 tins and get 5% off, or 5 tins for 10% off. Mix freely from all four flavors.';
    if(t.indexOf(o)>-1)el.textContent=t.replace(o,'The minimum order is 3 tins. Mix freely from all four flavors.');
  });

  /* set exact quantities by pressing the existing + and - buttons */
  function setQty(map,btnSel,outSel){
    FL.forEach(function(f){
      var out=$(outSel(f.id)),want=map[f.id]||0,g=60;
      while(out&&num(out)>want&&g--){var m=$(btnSel(f.id,-1));if(!m||m.disabled)break;m.click()}
      while(out&&num(out)<want&&g--){var p=$(btnSel(f.id,1));if(!p||p.disabled)break;p.click()}
    });
  }
  var pBtn=function(id,d){return '[data-pf="'+id+'"][data-d="'+d+'"]'},pOut=function(id){return '#pq-'+id};
  var mBtn=function(id,d){return '#brows [data-f="'+id+'"][data-d="'+d+'"]'},mOut=function(id){return '#q-'+id};
  var pTotal=function(){return FL.reduce(function(a,f){return a+num($(pOut(f.id)))},0)};
  var mTotal=function(){return FL.reduce(function(a,f){return a+num($(mOut(f.id)))},0)};
  var curFlavor=function(){var i=$$('.sw2').map(function(b){return b.getAttribute('aria-pressed')==='true'}).indexOf(true);return FL[i>-1?i:0]};
  var card=function(map,n){var o={};FL.forEach(function(f){o[f.id]=n});return o};

  /* product page */
  var pk=document.createElement('div');pk.id='packs';
  var lb=$('.pdp-lbl');
  if(lb&&lb.parentNode&&$('#swatches')){
    lb.parentNode.insertBefore(pk,lb);
    var busy=false;
    var refreshP=function(){
      if(busy)return;busy=true;
      var f=curFlavor(),t=pTotal();
      var same=function(n){return t===n&&num($(pOut(f.id)))===n};
      var mix=FL.every(function(x){return num($(pOut(x.id)))===1});
      pk.innerHTML='<p class="pdp-lbl">Pack size</p><div class="packs">'+
        [3,5].map(function(n){return '<button type="button" class="pk" data-pk="'+n+'" aria-pressed="'+same(n)+'">'+n+' tins<small>'+n+' × '+f.name+'</small></button>'}).join('')+
        '<button type="button" class="pk" data-pk="mix" aria-pressed="'+mix+'">Mix of '+FL.length+'<small>1 of each flavor</small></button></div><p class="pk-note">'+note+'</p>';
      var add=$('#pAdd'),hint=$('#pSizeTxt');
      if(add)add.disabled=t<MIN;
      if(t<MIN){
        if(add)add.textContent='Minimum '+MIN+' tins';
        if(hint)hint.textContent='Minimum '+MIN+' tins'+(t?'. Add '+(MIN-t)+' more.':'.');
      }else if(hint)hint.textContent='';
      busy=false;
    };
    var autoMin=function(){var t=pTotal();if(t>0&&t<MIN){var o={};o[curFlavor().id]=MIN;setQty(o,pBtn,pOut)}};
    pk.addEventListener('click',function(e){
      var b=e.target.closest('[data-pk]');if(!b)return;
      var v=b.getAttribute('data-pk'),o={};
      if(v==='mix')FL.forEach(function(x){o[x.id]=1});else o[curFlavor().id]=+v;
      setQty(o,pBtn,pOut);
    });
    var mo=new MutationObserver(refreshP);
    ['#pMixT','#pName'].forEach(function(s){var el=$(s);if(el)mo.observe(el,{childList:true,characterData:true,subtree:true})});
    document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.sw2'))setTimeout(function(){autoMin();refreshP()},0)});
    addEventListener('hashchange',function(){setTimeout(function(){autoMin();refreshP()},0)});
    autoMin();refreshP();
  }

  /* quick add on flavor cards and favorites: always the minimum pack */
  document.addEventListener('click',function(e){
    var t=e.target;if(!t.closest)return;
    var a=t.closest('[data-add]'),f=t.closest('[data-fadd]'),id=a?a.getAttribute('data-add'):(f?f.getAttribute('data-fadd'):null);
    if(!id||!window.SmeloCart)return;
    e.stopPropagation();e.preventDefault();
    var o={};o[id]=MIN;
    if(f){var pop=$('#favPop'),of=$('#openFav');if(pop)pop.hidden=true;if(of)of.setAttribute('aria-expanded','false')}
    SmeloCart.addFlavors(o);
  },true);

  /* mix builder */
  var br=$('#brows');
  if(br&&$('#bAdd')){
    br.insertAdjacentHTML('beforebegin','<div class="packs" id="mixPacks"><button type="button" class="pk" data-mp="1">Mix of '+FL.length+'<small>1 of each flavor</small></button><button type="button" class="pk" data-mp="2">Mix of '+(FL.length*2)+'<small>2 of each flavor</small></button></div><p class="pk-note">'+note+'</p>');
    $('#mixPacks').addEventListener('click',function(e){
      var b=e.target.closest('[data-mp]');if(!b)return;
      setQty(card({},+b.getAttribute('data-mp')),mBtn,mOut);
    });
    var refreshM=function(){
      var t=mTotal(),a=$('#bAdd'),b=$('#bBuy'),h=$('#bHint');
      if(a)a.disabled=t<MIN;if(b)b.disabled=t<MIN;
      if(t>0&&t<MIN){
        if(a)a.textContent='Minimum '+MIN+' tins';
        var m='Minimum '+MIN+' tins. Add '+(MIN-t)+' more, or tap a mix above.';
        if(h&&h.textContent!==m)h.textContent=m;
      }else if(t>=MIN&&h&&h.textContent)h.textContent='';
    };
    var h0=$('#bHint');if(h0)new MutationObserver(refreshM).observe(h0,{childList:true,characterData:true,subtree:true});
    refreshM();
  }
})();